import ISidebarService from "features/shared/layout/sidebar/services/ISidebarService";
import SidebarService from "features/shared/layout/sidebar/services/SidebarService";
import IPersistentLog from "infrastructure/logging/IPersistentLog";
import PersistentLog from "infrastructure/logging/PersistentLog";
import IContentDialogService from 'features/shared/components/contentDialog/IContentDialogService';
import ContentDialogService from 'features/shared/components/contentDialog/ContentDialogService';
import AddressService from 'features/shared/services/AddressService';
import IAddressService from 'features/shared/services/IAddressService';
import { ContainerModule, interfaces } from "inversify";
import { IocTypes } from "../ioc.types";

export const sharedModule = new ContainerModule((bind: interfaces.Bind) => {
  bind<ISidebarService>(IocTypes.SidebarService).to(SidebarService);
  bind<IPersistentLog>(IocTypes.PersistentLog).to(PersistentLog);
  bind<IContentDialogService>(IocTypes.ContentDialogService).to(ContentDialogService);
  bind<IAddressService>(IocTypes.AddressService).to(AddressService);
});